import * as React from "react";
import { Link } from "react-router-dom";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { QueryOrderDirection } from "../../misc/api/apiTypes";
import DocumentTitle from "../../misc/components/DocumentTitle";
import { useQueryTable } from "../../misc/components/queryTable/Hooks/UseQueryTable";
import { DiaryConfigurationsTable } from "./DiaryConfigurationsTable";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { Authorization } from "../../misc/components/Authorization";
import { useSecurityContext } from "../../Core/SecurityContext";

export const DiaryConfigurationsList = () => {
    const { study, tableParameters } = useCurrentStudyConfigurationContext();
    const { currentUserPermissions } = useSecurityContext();

    const queryTableReducer = useQueryTable({
        query: {
            Order: {
                Member: "Name",
                Direction: QueryOrderDirection.Ascending,
            },
            Page: {
                Current: 1,
                Length: tableParameters.DefaultPageSize,
            },
            Filters: []
        }
    });
    const [tableState, tableDispatch] = queryTableReducer;

    return (
        <DocumentTitle title="Diary Configurations | Vitalograph Web Portal">
            <div className="row">
                <div className="col-md-6">
                    <h2 className="text-primary">Diary Configurations</h2>
                </div>
                <div className="col-md-6">
                    <div className="h2 pull-right">
                        <Authorization
                            permissionId={PermissionEnum.CreateEDiaryConfiguration}
                            studyId={study.id}
                            currentPermissions={currentUserPermissions}
                        >
                            <Link id="createNew" className="btn btn-primary" to="/DiaryConfigurations/Create">
                                Create New
                            </Link>&nbsp;
                        </Authorization>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div className="panel panel-default">
                        <div className="panel-body">
                            <div className="table-responsive">
                                <DiaryConfigurationsTable queryTableReducer={queryTableReducer} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </DocumentTitle>
    );
}
